// 2023 US Census delineation files have comparable codes between MSAs and CBSAs
// https://www.census.gov/geographies/reference-files/time-series/demo/metro-micro/delineation-files.html
export const CBSA_TO_MSA_MAP = {
  'Anniston-Oxford, AL': 'Anniston-Oxford-Jacksonville, AL',
  'Austin-Round Rock-San Marcos, TX': 'Austin-Round Rock, TX',
  'Bakersfield-Delano, CA': 'Bakersfield, CA',
  'Bend, OR': 'Bend-Redmond, OR',
  'Birmingham, AL': 'Birmingham-Hoover, AL',
  'Bremerton-Silverdale-Port Orchard, WA': 'Bremerton-Silverdale, WA',
  'Bridgeport-Stamford-Danbury, CT': 'Bridgeport-Stamford-Norwalk, CT',
  'Brunswick-St. Simons, GA': 'Brunswick, GA',
  'Buffalo-Cheektowaga, NY': 'Buffalo-Cheektowaga-Niagara Falls, NY',
  'Chambersburg, PA': 'Chambersburg-Waynesboro, PA',
  'Chicago-Naperville-Elgin, IL-IN': 'Chicago-Naperville-Elgin, IL-IN-WI',
  'Dayton-Kettering-Beavercreek, OH': 'Dayton-Kettering, OH',
  'Denver-Aurora-Centennial, CO': 'Denver-Aurora-Lakewood, CO',
  'Elizabethtown, KY': 'Elizabethtown-Fort Knox, KY',
  'Eugene-Springfield, OR': 'Eugene, OR',
  'Evansville, IN': 'Evansville, IN-KY',
  'Fairbanks-College, AK': 'Fairbanks, AK',
  'Fayetteville-Springdale-Rogers, AR': 'Fayetteville-Springdale-Rogers, AR-MO',
  'Fort Collins-Loveland, CO': 'Fort Collins, CO',
  'Grand Rapids-Wyoming-Kentwood, MI': 'Grand Rapids-Wyoming, MI',
  'Greenville-Anderson-Greer, SC': 'Greenville-Anderson-Mauldin, SC',
  'Gulfport-Biloxi, MS': 'Gulfport-Biloxi-Pascagoula, MS',
  'Hilton Head Island-Bluffton-Port Royal, SC': 'Hilton Head Island-Bluffton-Beaufort, SC',
  'Houma-Bayou Cane-Thibodaux, LA': 'Houma-Thibodaux, LA',
  'Houston-Pasadena-The Woodlands, TX': 'Houston-The Woodlands-Sugar Land, TX',
  'Indianapolis-Carmel-Greenwood, IN': 'Indianapolis-Carmel-Anderson, IN',
  'Joplin, MO-KS': 'Joplin, MO',
  'Kahului-Wailuku, HI': 'Kahului-Wailuku-Lahaina, HI',
  'Kingsport-Bristol, TN-VA': 'Kingsport-Bristol-Bristol, TN-VA',
  'Las Vegas-Henderson-North Las Vegas, NV': 'Las Vegas-Henderson-Paradise, NV',
  'Longview-Kelso, WA': 'Longview, WA',
  'Mankato, MN': 'Mankato-North Mankato, MN',
  'Milwaukee-Waukesha, WI': 'Milwaukee-Waukesha-West Allis, WI',
  'Muskegon-Norton Shores, MI': 'Muskegon, MI',
  'Myrtle Beach-Conway-North Myrtle Beach, SC': 'Myrtle Beach-Conway-North Myrtle Beach, SC-NC',
  'Naples-Marco Island, FL': 'Naples-Immokalee-Marco Island, FL',
  'New Haven, CT': 'New Haven-Milford, CT',
  'New York-Newark-Jersey City, NY-NJ': 'New York-Newark-Jersey City, NY-NJ-PA',
  'Niles, MI': 'Niles-Benton Harbor, MI',
  'North Port-Bradenton-Sarasota, FL': 'North Port-Sarasota-Bradenton, FL',
  'Norwich-New London-Willimantic, CT': 'Norwich-New London, CT',
  'Ogden, UT': 'Ogden-Clearfield, UT',
  'Olympia-Lacey-Tumwater, WA': 'Olympia-Tumwater, WA',
  'Omaha, NE-IA': 'Omaha-Council Bluffs, NE-IA',
  'Panama City-Panama City Beach, FL': 'Panama City, FL',
  'Phoenix-Mesa-Chandler, AZ': 'Phoenix-Mesa-Scottsdale, AZ',
  'Provo-Orem-Lehi, UT': 'Provo-Orem, UT',
  'Racine-Mount Pleasant, WI': 'Racine, WI',
  'Raleigh-Cary, NC': 'Raleigh, NC',
  'Sacramento-Roseville-Folsom, CA': 'Sacramento--Roseville--Arden-Arcade, CA',
  'Salisbury, MD': 'Salisbury, MD-DE',
  'Salt Lake City-Murray, UT': 'Salt Lake City, UT',
  'San Diego-Chula Vista-Carlsbad, CA': 'San Diego-Carlsbad, CA',
  'San Francisco-Oakland-Fremont, CA': 'San Francisco-Oakland-Hayward, CA',
  'San Luis Obispo-Paso Robles, CA': 'San Luis Obispo-Paso Robles-Arroyo Grande, CA',
  'Santa Rosa-Petaluma, CA': 'Santa Rosa, CA',
  'Scranton--Wilkes-Barre, PA': 'Scranton--Wilkes-Barre--Hazleton, PA',
  'Sebastian-Vero Beach-West Vero Corridor, FL': 'Sebastian-Vero Beach, FL',
  'Sioux Falls, SD-MN': 'Sioux Falls, SD',
  'Staunton-Stuarts Draft, VA': 'Staunton-Waynesboro, VA',
  'Trenton-Princeton, NJ': 'Trenton, NJ',
  'Vallejo, CA': 'Vallejo-Fairfield, CA',
  'Vineland, NJ': 'Vineland-Bridgeton, NJ',
  'Virginia Beach-Chesapeake-Norfolk, VA-NC': 'Virginia Beach-Norfolk-Newport News, VA-NC',
  'Visalia, CA': 'Visalia-Porterville, CA',
  'Wenatchee-East Wenatchee, WA': 'Wenatchee, WA',
  'Worcester, MA': 'Worcester, MA-CT',
  'Youngstown-Warren, OH': 'Youngstown-Warren-Boardman, OH-PA'
};

export const NONCONTINENTAL_CBSAS = {
  ALASKA: ['Anchorage, AK', 'Fairbanks-College, AK'],
  HAWAII: ['Kahului-Wailuku, HI', 'Urban Honolulu, HI']
};
